import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

import withStyles from '~src/lib/isomorphic-style-loader/withStyles';

import s from './Announcement.scss';

const DISMISSED_KEY = 'announcementG2DismissedV2';

const Announcement = () => {
  const [isDismissed, setIsDismissed] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const announcementDismissed = window.localStorage.getItem(DISMISSED_KEY);
    if (announcementDismissed === 'true') {
      setIsDismissed(true);
    }

    const path = window.location.pathname.split('/')[1];
    // If NOT admin, show the announcement
    if (!['admin'].includes(path)) {
      setIsVisible(true);
    }
  }, []);

  if (!isVisible || isDismissed) {
    return null;
  }

  const handleDismiss = () => {
    window.localStorage.setItem(DISMISSED_KEY, true);
    setIsDismissed(true);
  };

  const primaryLink = {
    url:
      'https://www.g2.com/contributor/narvar-amazon50-new-5ef1cc48-b972-44f5-84a2-298022d95062?secure%5Bpage_id%5D=narvar-amazon50-new-5ef1cc48-b972-44f5-84a2-298022d95062&secure%5Brewards%5D=true&secure%5Btoken%5D=bd5f42a3c629fbac5097b2904fc18193ea87e1944df020c6921dce79583a32d0&utm_source=Narvar&utm_medium=hub&utm_campaign=pushdown_banner',
    text: 'Start Review',
    attrs: {
      target: '_blank',
      rel: 'noopener noreferrer',
    },
  };

  return (
    <div className={s.announcement}>
      <div className={s.announcementContent}>
        <span role="img" aria-label="gift" className={s.emoji}>
          🎁
        </span>{' '}
        <div className={s.copyWrap}>
          <p className={s.announcementCopy}>
            <strong>Review Us:</strong> Leave a G2 review and get a{' '}
            <strong>$50 gift card</strong> as a token of our appreciation!
          </p>
          <Box
            style={{
              display: 'inline-flex',
              gap: '8px',
            }}
          >
            <Button
              color="secondary"
              variant="contained"
              href={primaryLink.url}
              style={{
                whiteSpace: 'nowrap',
                height: '40px',
                borderRadius: '4px',
                color: '#fff',
              }}
              {...primaryLink.attrs}
            >
              {primaryLink.text}
            </Button>
            <Button
              color="secondary"
              variant="text"
              onClick={handleDismiss}
              style={{
                height: '40px',
                borderRadius: '4px',
                color: '#1399D6',
              }}
            >
              Dismiss
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default withStyles(s)(Announcement);
